export default {
  path: 'temporary-regulations/crews/:id',
  name: 'TemporaryRegulationsCrewDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/CrewDetails.vue')
}
